<template>
  <tr>
    <td>{{ punto.persona_nombre }} {{ punto.persona_apellido }}</td>
    <td>{{ punto.ubicacion }}</td>
    <td class="no-padding">
      <ul class="puntos_entrega_productos_lista">
        <PuntosDeEntregaListaItemProducto
          v-for="item in punto.stock"
          :item="item"
          :key="item.producto_id + '.' + item.color"
        ></PuntosDeEntregaListaItemProducto>
      </ul>
    </td>
    <td>
      <div class="contenor_botones_form_stock">
        <router-link :to="`/editar-punto-de-entrega/${punto.punto_de_entrega_id}`" class="boton-editar">Editar</router-link>
        <!-- <button @click="borrarPuntoEntrega(punto.punto_de_entrega_id)" class="boton-borrar">Borrar</button> -->
      </div>
    </td>
  </tr>
</template>

<script>
import PuntosDeEntregaListaItemProducto from '../components/PuntosDeEntregaListaItemProducto.vue'
import personasService from '../services/personas'
export default {
  name: 'PuntosDeEntregaListaItem',
  components: {
    PuntosDeEntregaListaItemProducto
  },
  props: ['punto'],
  data: function () {
    return {
      // store
    }
  },
  methods: {
    borrarPuntoEntrega (id) {
      console.log(id)
      personasService
        .borrarPuntoEntrega(id)
        .then(respuesta => {
          this.$emit('refrescar')
        })
    },
    abrirModal (id) {
      console.log(id)
      const confirmation = document.querySelector('.confirmation-' + id)
      confirmation.style.display = 'flex'
    },
    cerrarModal (id) {
      const confirmation = document.querySelector('.confirmation-' + id)
      confirmation.style.display = 'none'
    }
    // tipo (tipo) {
    //   switch (tipo) {
    //     case 1:
    //       return 'comercio_tipo_restaurant'
    //     case 2:
    //       return 'comercio_tipo_hotel'
    //     case 3:
    //       return 'comercio_tipo_bar'
    //   }
    //   return 'comercio_tipo_restaurant'
    // }
  },
  computed: {
    // imagenRuta: function () {
    //   return `${PATH_IMG}/${this.comercio.imagen}`
    // }
  }
}
</script>

<style>

.no-padding {
  padding: 0 !important;
}

.tabla-distribucion td, .tabla-distribucion th {
  border: 0 !important;
}

.tabla-distribucion th {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  background-color: #0984e3 !important;
}

#tabla-stock ul {
  /*list-style-type: none;*/
}

#tabla-stock ul li {
/*  margin: 12px 0;*/
}

.error-stock {
  background-color: red;
  color: white;
}

.boton-editar {
  padding: 4px;
  background-color: rgb(126,220,217);
  color: #2c3e50;
  border: 2px solid rgb(126,220,217);
  font-size: 1.1em;
  margin: 5px 0;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  border-radius: 4px;
}

.boton-editar:hover {
  background-color: #2c3e50;
  color: white;
  border: 2px solid #2c3e50;
}

.boton-borrar {
  padding: 8px;
  color: white;
  background-color: red;
  border-radius: 5px;
  font-size: 12px;
  border: 1px solid red;
  cursor: pointer;
  margin: 5px 0;
}

.contenor_botones_form_stock {
  height: auto;
  display: flex;
  flex-direction: column;
}
</style>
